const getEnvironment = (url) => {
  const regex1 = /integrate\.(qa|staging)\.decisivapps\.com/;
  const regex2 = /integrate\.(decisiv-paccar-escrow-20)\.com/;
  const match = url.match(regex1) || url.match(regex2);

  if (match) {
    return match[1];
  }

  return 'prod';
};

export default getEnvironment;
